import { Component, Input, OnInit } from '@angular/core';
import { AlertModalType } from 'src/app/app-modals/types/modal-params';

const alertTypeIcon = {
  info: 'uil uil-info-circle me-2',
  warning: 'uil uil-exclamation-triangle me-2',
  danger: 'uil uil-ban me-2',
};

/**
 * Alert modal.
 * 
 * This modal is used to display information, errors or warnings for 5 seconds without confirmation.
 * It can display either text or html
 */
@Component({
  selector: 'app-alert-modal',
  templateUrl: './alert-modal.component.html',
  styleUrls: ['./alert-modal.component.scss'],
})
export class AlertModalComponent implements OnInit {
  /**
   * Alert modal type. It can be "info", "warning", "danger"
   */
  @Input() type: AlertModalType = 'info';

  /**
   * Alert content in string
   */
  @Input() text: string = '';

  /**
   * Alert content in HTML
   */
  @Input() html: string = '';

  /**
   * Alert icon based on Alert modal type
   */
  public get icon() {
    return alertTypeIcon[this.type];
  }

  constructor() {}

  ngOnInit(): void {}
}
